import {AuthenticationService} from "@ispm/user/services/authentication.service";
import {AdvancedSearchService} from "@ispm/dashboard/services/advanced-search.service";
import {WorkflowService} from "@ispm/workflow/services/workflow.service";
import {UserActionCreatorService} from "@ispm/user/services/user-action-creator.service";
import {NavigationConfigService} from "@ispm/navigation/services/navigationConfig.service";
import {ThemingService} from "../../../theming/services/theming.service";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";
import {NavigationExtras, Router} from "@angular/router";
import {Injectable} from "@angular/core";

@Injectable({providedIn:'root'})
export class goToPathologist {
  constructor(private authenticationService: AuthenticationService,
              private advancedSearchService: AdvancedSearchService,
              private workflowService: WorkflowService,
              private userActionCreatorService: UserActionCreatorService,
              private navigationConfigService: NavigationConfigService,
              private themingService: ThemingService,
              private routerManagerService: RouterManagerService,
              private router: Router) {

  }

  resolve(){
    const usr = this.authenticationService.getUser();
    const organizationFromAdmin = new URLSearchParams(window.location.search).get('orgId');
    const isNavFromAdmin = new URLSearchParams(window.location.search).get('isNavFromAdmin');
    if(organizationFromAdmin && usr)
    {
      sessionStorage.setItem("adminSelectOrganizationId", organizationFromAdmin);
      this.authenticationService.user.organization = organizationFromAdmin;
      this.authenticationService.cleanUICustomResource();
      this.authenticationService.setCurrentUser(usr);
      this.userActionCreatorService.forceSetOrganizationConfiguration();
      this.userActionCreatorService.setEnvironmentDetails();
      this.workflowService.webConfig = null;
      return this.navigationConfigService.requestWebConfiguration(true).toPromise().then(data => {

        this.advancedSearchService.refetch();

        if (data && data.dashboard && data.dashboard.theme) {
          this.themingService.fetchTheme(data.dashboard.theme);

        } else {
          this.themingService.fetchDefaultTheme();
        }
        let firstNavigationItem;
        if(data.currentApp && data.currentApp.enable)
        {
          firstNavigationItem = data.currentApp.items.find(navItem => !!navItem.enable);
        }else {
          firstNavigationItem = data.navigation.items.find(navItem => !!navItem.enable);
        }
        if (firstNavigationItem) {
          const uriState = firstNavigationItem.redirectUrl.split(/[?#]/)[0];

          const params =  this.routerManagerService.getUrlParams(firstNavigationItem.redirectUrl).queryParams;
          if (parseInt(isNavFromAdmin) === 1) {
            sessionStorage.setItem("isNavFromAdmin", JSON.stringify(true));
          }
          const navigationExtras: NavigationExtras = {
            queryParams: params,
            state: { hadEnterInit: true },
            replaceUrl: true
          };

          this.router.navigate([uriState], navigationExtras);
        } else {
          console.log('Failed moving to WorkList:',firstNavigationItem);
          this.router.navigate(['Pathologist'] ,{ queryParams: { hadEnterInit: true , location: true }});
        }
      }).catch(function (err) {
        console.log('Failed moving to WorkList:' + err.message);
      });
    }
    else {
      console.log('org id null');
    }
  }
}

